// extracted by mini-css-extract-plugin
export var darkMode = "_d-0";